import Address from 'root/apps/QuoteMachineIntegration/state/Address';
import { datadogLogs } from 'root/datadog/datadogLogs';

export default class Location {
  lsLocationId: string;
  name: string;
  email: string;
  address: Address;
  constructor(location: Shop | null) {
    if (!location) {
      datadogLogs.logger.error('Shop / Location data is required for the invoicing module');
    }

    this.lsLocationId = location?.shopID || '';
    this.name = location?.name || '';
    this.address = location?.Contact?.Addresses?.ContactAddress
      ? new Address(location?.Contact?.Addresses?.ContactAddress)
      : new Address({
          address1: '',
          address2: '',
          city: '',
          state: '',
          stateCode: '',
          zip: '',
          country: '',
          countryCode: '',
        });

    let customerEmail = '';

    if (typeof location?.Contact?.Emails === 'object' && location?.Contact?.Emails?.ContactEmail) {
      const contactEmail = location.Contact.Emails.ContactEmail;
      if (Array.isArray(contactEmail)) {
        customerEmail = contactEmail[0]?.address || '';
      } else {
        customerEmail = contactEmail.address || '';
      }
    }
    this.email = customerEmail.toString();
  }
}
